import { Card } from 'ui-components/components/card';

import style from './tool-card.module.less';

import type React from 'react';

export type ToolCardProps = {
  children: React.ReactNode;
  isVisible?: boolean;
};

export const ToolCard: React.FC<ToolCardProps> = ({ children, isVisible = true }) => {
  if (!isVisible) return null;

  return <Card className={style['tool-card']}>{children}</Card>;
};
